module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 22
// module chunks = 0 1